import React from 'react';
import GamesDetails from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE, PC_CONSOLE_COMBINE_MODULE_NAME } from '@intelligence/pages/TopCharts/_config/topChartsConst';

const PCConsoleGameDetails: React.FC = (props) => (
  <GamesDetails {...props} entityType={PC_CONSOLE_COMBINE_ENTITY_TYPE} moduleName={PC_CONSOLE_COMBINE_MODULE_NAME} />
);

export default PCConsoleGameDetails;
